import React from "react"

import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"

/**
 * Find an item using the provided find function, and redirect to the index path if the function returns undefined or
 * throws an error.
 * @param id
 * @param find
 * @param indexPath
 */
const useFindItemOrRedirect = <T extends { id: number }>(
  id: string | undefined,
  find: (id: number) => T | undefined,
  indexPath: string,
): T | undefined => {
  const navigateNoUpdate = useNavigateNoUpdate()

  const item = React.useMemo(() => {
    if (id !== undefined) {
      try {
        return find(Number(id))
      } catch {
        return undefined
      }
    }
  }, [id, find])

  React.useEffect(() => {
    if (id !== undefined && item === undefined) navigateNoUpdate(indexPath)
  }, [id, item, indexPath, navigateNoUpdate])

  return item
}

export default useFindItemOrRedirect
